import { setSelectedLocation } from "components";
import { DealersAndLocationsDropdownKeys } from "components/DealersAndLocationsDropdown/queryKeys";
import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";

import type { DealerLocation } from "models";

export type LocationDetailFormPayload = Pick<
  DealerLocation,
  | "name"
  | "commercial_name"
  | "headline"
  | "footerline"
  | "country"
  | "city"
  | "street"
  | "postal_code"
  | "phone_nr"
  | "language_code"
  | "logo"
  | "company_stamp"
  | "ip_address_enabled"
  | "is_employee_name_visible"
  | "is_car_note_enabled"
  | "is_customer_note_enabled"
  | "redirect_to_new_web_version"
  | "key_label_type_id"
  | "key_label_layout_id"
  | "keylocker_code"
  | "dms_location_source"
  | "can_add_intervention_elements"
  | "default_customer_ok_for_dms_lease_intervention"
  | "planit_planning_replacement_vehicle"
  | "xentry_sub_outlet_id"
  | "auto_unpin_appointment_statuses"
  | "unpin_past_appointments_older_than"
  | "unpin_future_appointments_further_than"
  | "unpin_appointments_on_is_billed"
  | "unpin_appointments_on_car_out_of_shop"
  | "enabled_appointment_note_type_ids"
  | "all_season_a_threshold"
  | "all_season_n_threshold"
  | "summer_a_threshold"
  | "summer_n_threshold"
  | "winter_a_threshold"
  | "winter_n_threshold"
  | "truck_tyre_a_threshold"
  | "truck_tyre_n_threshold"
  | "is_tyre_status_always_visible_on_wo"
  | "statuses"
  | "is_assigned_wo_status_change_notification_enabled"
  | "web_clock_omgeving_id"
  | "planit_planning_establishment_id"
> & {
  ip_addresses: string;
};

export const useUpdateLocationMutation = () =>
  useTypedMutation({
    mutationFn: async (payload: DealerLocation) => (await ApiInstance.post("/locations/update", payload, ENV.dealerBaseURL)).data,
    onSuccess: payload => {
      const dealersList = typedQueryClient.getQueryData(DealersAndLocationsDropdownKeys.dealers);
      const dealerIdx = dealersList?.dealers.findIndex(dealer => dealer.id === payload.dealer_id) ?? -1;

      if (dealersList && dealerIdx !== -1) {
        const dealer = dealersList.dealers[dealerIdx];
        const locationIdx = dealer.locations?.findIndex(location => location.id === payload.id) ?? -1;

        if (dealer.locations && locationIdx !== -1)
          typedQueryClient.setQueryData(DealersAndLocationsDropdownKeys.dealers, {
            ...dealersList,
            dealers: dealersList.dealers.with(dealerIdx, {
              ...dealer,
              locations: dealer.locations.with(locationIdx, {
                ...dealer.locations[locationIdx],
                ...payload
              })
            })
          });
      }

      const selectedLocation = typedQueryClient.getQueryData(DealersAndLocationsDropdownKeys.selectedLocation);
      if (!selectedLocation) return;

      setSelectedLocation({ ...selectedLocation, ...payload });
    }
  });
